module.exports = __webpack_public_path__ + "static/sberbank-logo-d3d5c156017763be5f13b7f2aaec49d9.png";